var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilledTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1334_55101",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1334_55101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 12.5007C9.11103 12.5007 10.0555 12.1118 10.8333 11.334C11.611 10.5562 11.9999 9.61176 11.9999 8.50065C11.9999 7.53398 11.6916 6.68398 11.0749 5.95065C10.4583 5.21732 9.6777 4.75621 8.73325 4.56732C8.53325 4.5451 8.36103 4.60065 8.21659 4.73398C8.07214 4.86732 7.99992 5.03398 7.99992 5.23398V8.50065L5.69992 10.8007C5.55547 10.9451 5.48881 11.1173 5.49992 11.3173C5.51103 11.5173 5.59436 11.6784 5.74992 11.8007C6.07214 12.0562 6.4277 12.2368 6.81659 12.3423C7.20547 12.4479 7.59992 12.5007 7.99992 12.5007ZM7.99992 15.1673C7.0777 15.1673 6.21103 14.9923 5.39992 14.6423C4.58881 14.2923 3.88325 13.8173 3.28325 13.2173C2.68325 12.6173 2.20825 11.9118 1.85825 11.1007C1.50825 10.2895 1.33325 9.42287 1.33325 8.50065C1.33325 7.57843 1.50825 6.71176 1.85825 5.90065C2.20825 5.08954 2.68325 4.38398 3.28325 3.78398C3.88325 3.18398 4.58881 2.70898 5.39992 2.35898C6.21103 2.00898 7.0777 1.83398 7.99992 1.83398C8.92214 1.83398 9.78881 2.00898 10.5999 2.35898C11.411 2.70898 12.1166 3.18398 12.7166 3.78398C13.3166 4.38398 13.7916 5.08954 14.1416 5.90065C14.4916 6.71176 14.6666 7.57843 14.6666 8.50065C14.6666 9.42287 14.4916 10.2895 14.1416 11.1007C13.7916 11.9118 13.3166 12.6173 12.7166 13.2173C12.1166 13.8173 11.411 14.2923 10.5999 14.6423C9.78881 14.9923 8.92214 15.1673 7.99992 15.1673ZM7.99992 13.834C9.48881 13.834 10.7499 13.3173 11.7833 12.284C12.8166 11.2507 13.3333 9.98954 13.3333 8.50065C13.3333 7.01176 12.8166 5.75065 11.7833 4.71732C10.7499 3.68398 9.48881 3.16732 7.99992 3.16732C6.51103 3.16732 5.24992 3.68398 4.21659 4.71732C3.18325 5.75065 2.66659 7.01176 2.66659 8.50065C2.66659 9.98954 3.18325 11.2507 4.21659 12.284C5.24992 13.3173 6.51103 13.834 7.99992 13.834Z",
    fill: "black",
    fillOpacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledTime);
export default __webpack_public_path__ + "static/media/FilledTime.dbf28740b1499c07770842cd42951bb3.svg";
export { ForwardRef as ReactComponent };